var _a;
var shouldToggleIcons;
var zipcode;
var managementCompanyID;
var filterLessUrl;
var numberOfItemsToShowPerPage;
globalThis.showcaseItemID = (_a = globalThis.showcaseItemID) !== null && _a !== void 0 ? _a : 0;
var showMap;
//let imageDomain : string; --> Declared in apartment-window-types.d.ts
var priceRange;
var neighborhoods;
var bedroomRange;
var bathroomRange;
var travelTime;
var travelBy;
var addressLat;
var addressLong;
var byUnit;
var byUnitDefault;
var detailsLinkBase;
var unitPrices;
var roomPrices;
var bedrooms;
var bathrooms;
var polygonCoordinates;
var hidePolygon;
var cacheKeyRandomString;
var neighborhoodMapCenterKey;
var neighborhoodMapCenterValue;
var clusterMarkers;
var clusterQuantity;
var brandColorPrimary;
var brandColorSecondary;
var abShowAlternate;
var abMainImageName;
//var hasRoles: boolean; --> Declared in apartment-window-types.d.ts
var loggedIn;
var cityName;
var lastSearchSeen;
var featuredIconText;
var isInitialLoad;
var showInitialKnockoutView;
var mapsAreInitialized;
var loadingMaps;
var allowMapHoverInteraction = false;
/**
* This is used to cache the results of the initial page load of showcase items that came from the server-side. We
* are doing this so that when we make initialize the javascript knockout view model, the data we fetch comes
* back with the exact same results to avoid any flickering or changes in the UI.
*/
var resultsCacheKey;
var initialItems;
globalThis.loaded = false;
var trackedABViews = [];
featuredIconText = featuredIconText || "Icon Community";
var filterEventTracked = false;
var initialFilterDisplay = true;
var ils;
(function (ils) {
    var showcaseListings;
    (function (showcaseListings) {
        let cdpClicks = 0;
        let attributeClicks = 0;
        let filterUses = 0;
        showcaseListings.filterUndos = 0;
        let priceUsed = false;
        let bedUsed = false;
        let bathUsed = false;
        let travelTimeUsed = false;
        // Bumped on every LoadNewSet() call so a stale, still-running list load can detect
        // it's been superseded by a newer filter tap and stop doing work instead of racing it.
        let loadGeneration = 0;
        // Aborts the in-flight LoadMapPins() request when a newer filter tap supersedes it.
        let mapPinsAbortController = null;
        // Bumped whenever the price-widen suggestion counts are recalculated so stale responses are ignored.
        let priceRangeAddsRequestId = 0;
        class FilterItem {
            constructor(attributeID, type, value, title) {
                var self = this;
                this.AttributeID = attributeID;
                this.Title = title;
                this.Type = type;
                this.Value = ko.observable(value);
                this.ClearFilter = () => {
                    this.Value("");
                    const siblingFilter = $(`input[type=hidden][value=${this.AttributeID}]`).next();
                    if (this.Type === "RangeSlider")
                        ClearRangeSlider(siblingFilter.find("> div"));
                    else if (this.Type === "CheckBoxList" || this.Type === "RadioButtonGrid") {
                        siblingFilter.find(":checkbox").each(function () {
                            ClearCheckBox($(this));
                        });
                    }
                    else if (this.Type === "DropDown")
                        globalThis.ClearListBoxOrDropDown(siblingFilter);
                    else if (this.Type === 'RadioButtonList') {
                        $(".filters input[type='hidden'][value='" + this.AttributeID + "']").nextAll("[id*=uxFilterRadioButtonList]").find("input[type='radio']")
                            .each(function () {
                            ClearRadioButtonList($(this));
                        });
                    }
                };
                this.Value.subscribe(function (newValue) {
                    showcaseListings.viewModel.FiltersChanged(newValue !== self.Value());
                });
            }
        }
        showcaseListings.FilterItem = FilterItem;
        function GetFilterByID(attributeID) {
            try {
                const attrId = !attributeID ? 0 : parseInt(attributeID);
                let filterItem = ko.utils.arrayFirst(showcaseListings.viewModel.FilterList(), function (item) {
                    return item.AttributeID === attrId;
                });
                if (!filterItem) {
                    filterItem = new FilterItem(attrId, "", "", "");
                }
                return filterItem;
            }
            catch (e) {
                console.error(e);
                return new FilterItem(0, "", "", "");
            }
        }
        showcaseListings.viewModel = {
            FilterList: ko.observableArray([]),
            FiltersChanged: ko.observable(false),
            ShowMobileFilters: ko.observable(false),
            AddressText: ko.observable($("input[id*=uxFilterAddress]").length > 0 ? $("input[id*=uxFilterAddress]").val() : ""),
            // Prefer server-geocoded coords from prefiltered landing pages so LoadMapPins matches the
            // filtered initialItems list (browser geocode is async and used to race the pin fetch).
            AddressLat: ko.observable(typeof addressLat !== "undefined" && addressLat != null ? String(addressLat) : null),
            AddressLong: ko.observable(typeof addressLong !== "undefined" && addressLong != null ? String(addressLong) : null),
            SearchText: ko.observable($("input[id*=uxSearchText]").val()),
            PageNumber: ko.observable(1),
            PageSize: ko.observable(numberOfItemsToShowPerPage),
            TotalRowCount: ko.observable(0),
            Loading: ko.observable(showInitialKnockoutView),
            Listings: ko.observableArray([]),
            LazyLoadedListings: ko.observableArray([]),
            ReadyToLoadData: ko.observable(false),
            PriceRange: ko.observable(priceRange),
            PriceRangeAdds: ko.observableArray([0, 0]),
            ByUnit: ko.observable(byUnit),
            Neighborhoods: ko.observable(neighborhoods),
            BedroomRange: ko.observable(bedroomRange),
            BathroomRange: ko.observable(bathroomRange),
            TravelTime: ko.observable(travelTime),
            TravelBy: ko.observable(travelBy),
            Zipcode: ko.observable(zipcode),
            ManagementCompanyID: ko.observable(managementCompanyID),
            PolygonCoordinates: ko.observable(""),
            Favorites: ko.observableArray([]),
            Trash: ko.observableArray([]),
            MapMode: ko.observable(null),
            Error: ko.observable(null),
            PriceMin: ko.observable(null),
            PriceMax: ko.observable(null),
            BedroomMin: ko.observable(null),
            BedroomMax: ko.observable(null),
            BathroomMin: ko.observable(null),
            BathroomMax: ko.observable(null),
            FeaturedIcons: ko.observableArray([]),
            ShowKnockoutView: ko.observable(showInitialKnockoutView),
            OriginalLocationHref: ko.observable(location.href),
            MobileFilterPendingRefresh: ko.observable(false)
        };
        showcaseListings.viewModel.ActiveFilters = ko.computed(function () {
            return ko.utils.arrayFilter(showcaseListings.viewModel.FilterList(), function (item) {
                return item.Value() !== "";
            });
        });
        showcaseListings.viewModel.Filter = ko.computed(function () {
            var allFilters = [];
            ko.utils.arrayForEach(showcaseListings.viewModel.ActiveFilters(), function (item) {
                allFilters.push(`${item.AttributeID}:${item.Value()}|`);
            });
            return allFilters.join("").replace(/\|*$/, "");
        });
        showcaseListings.viewModel.LastIndexVisible = ko.computed(function () {
            return showcaseListings.viewModel.PageNumber() * showcaseListings.viewModel.PageSize() > showcaseListings.viewModel.TotalRowCount() ? showcaseListings.viewModel.TotalRowCount() : showcaseListings.viewModel.PageNumber() * showcaseListings.viewModel.PageSize();
        });
        showcaseListings.viewModel.NextEnabled = ko.computed(function () {
            return (showcaseListings.viewModel.LastIndexVisible() > showcaseListings.viewModel.TotalRowCount() ? showcaseListings.viewModel.TotalRowCount() : showcaseListings.viewModel.LastIndexVisible()) !== showcaseListings.viewModel.TotalRowCount();
        });
        showcaseListings.viewModel.ZipcodeClean = ko.computed(function () {
            return showcaseListings.viewModel.Zipcode() === "All" ? "" : showcaseListings.viewModel.Zipcode();
        });
        showcaseListings.viewModel.ManagementCompanyIDClean = ko.computed(function () {
            return showcaseListings.viewModel.ManagementCompanyID() === "All" ? "" : showcaseListings.viewModel.ManagementCompanyID();
        });
        /**
         * Displays the next page of listings based on what's in the current viewModel.LazyLoadedListings() and
         * updates the view model.
         * If the next page is enabled, it increments the page number and performs necessary operations.
         * If showMap and mapsAreInitialized are true, it iterates through the lazy loaded listings and calls
         * codeAddress for each listing.
         * Finally, it updates the view and adds the lazy loaded listings to the main listings array.
         * @returns {Promise<void>}
         */
        async function ShowNextPage() {
            if (!showcaseListings.viewModel.NextEnabled()) {
                return;
            }
            showcaseListings.viewModel.PageNumber(showcaseListings.viewModel.PageNumber() + 1);
            // Map markers are no longer placed page-by-page here - LoadMapPins() fetches and places
            // a pin for every matching result (via a dedicated lightweight endpoint) once per filter
            // change, independent of how much of the visible list has been scrolled into view.
            showcaseListings.viewModel.ShowKnockoutView(true);
            for (let i = 0; i < showcaseListings.viewModel.LazyLoadedListings().length; i++) {
                showcaseListings.viewModel.Listings.push(showcaseListings.viewModel.LazyLoadedListings()[i]);
            }
            await LazyLoadNextPage();
        }
        showcaseListings.viewModel.NextClicked = function () {
            ShowNextPage();
            return false;
        };
        showcaseListings.viewModel.MapMode.subscribe(function (newValue) {
            showcaseListings.drawingManager.setDrawingMode(newValue === "polygon" ? google.maps.drawing.OverlayType.POLYGON : null);
            if (showcaseListings.map) {
                showcaseListings.map.setOptions({ draggableCursor: (newValue === "freeform" ? "crosshair" : null), draggable: newValue !== "freeform" });
                if (showcaseListings.isDrawing && showcaseListings.polyline)
                    google.maps.event.trigger(showcaseListings.polyline, "mouseup");
            }
        });
        showcaseListings.viewModel.EncodedPolygon = ko.computed(function () {
            return showcaseListings.viewModel.PolygonCoordinates() && showcaseListings.viewModel.PolygonCoordinates() !== "" && ((typeof (showcaseListings.polyline) != "undefined" && showcaseListings.polyline) || (typeof (showcaseListings.polygon) != "undefined" && showcaseListings.polygon)) ? google.maps.geometry.encoding.encodePath((showcaseListings.polyline && showcaseListings.polyline.getPath().getArray().length > 0 ? showcaseListings.polyline : showcaseListings.polygon).getPath().getArray()) : "";
        });
        showcaseListings.viewModel.FilterString = ko.computed(function () {
            const queryParams = new URLSearchParams(); // Use URLSearchParams to manage query parameters
            function removeDuplicateValues(value) {
                if (!value)
                    return value;
                const uniqueValues = [...new Set(value.split(","))];
                return uniqueValues.join(",");
            }
            // Add parameters if they exist and are valid
            if (showcaseListings.viewModel.PriceRange())
                queryParams.append("PriceRange", showcaseListings.viewModel.PriceRange());
            if (showcaseListings.viewModel.ByUnit() !== byUnitDefault)
                queryParams.append("ByUnit", showcaseListings.viewModel.ByUnit().toString());
            if (showcaseListings.viewModel.BedroomRange())
                queryParams.append("Bedrooms", showcaseListings.viewModel.BedroomRange());
            if (showcaseListings.viewModel.BathroomRange())
                queryParams.append("Bathrooms", showcaseListings.viewModel.BathroomRange());
            if (showcaseListings.viewModel.Neighborhoods())
                queryParams.append("Neighborhoods", showcaseListings.viewModel.Neighborhoods());
            if (showcaseListings.viewModel.Filter())
                queryParams.append("Filters", showcaseListings.viewModel.Filter());
            if (showcaseListings.viewModel.SearchText())
                queryParams.append("SearchText", showcaseListings.viewModel.SearchText());
            if (showcaseListings.viewModel.ZipcodeClean())
                queryParams.append("ZipCode", showcaseListings.viewModel.ZipcodeClean());
            if (showcaseListings.viewModel.ManagementCompanyIDClean())
                queryParams.append("ManagementCompanyID", showcaseListings.viewModel.ManagementCompanyIDClean());
            if (showcaseListings.viewModel.PolygonCoordinates()) {
                const encodedPolygon = showcaseListings.viewModel.EncodedPolygon().replace(/~/g, "%7e");
                queryParams.append("maparea", encodedPolygon);
            }
            // Handle address, travel time, and travel mode
            let address = showcaseListings.viewModel.AddressText().trim();
            if (address) {
                let existingAddress = queryParams.get("address") || "";
                let combinedAddresses = `${existingAddress},${address}`;
                address = removeDuplicateValues(combinedAddresses);
                queryParams.set("address", address);
                queryParams.set("traveltime", showcaseListings.viewModel.TravelTime());
                if (showcaseListings.viewModel.TravelBy() !== "drive") {
                    queryParams.set("travelby", showcaseListings.viewModel.TravelBy());
                }
            }
            // Convert query parameters to string and ensure consistency
            let queryString = queryParams.toString()
                .replace(/%20/g, "+") // Replace spaces with '+'
                .replace(/^\?+/, "") // Remove duplicate '?' on start
                .replace(/\?*$/, ""); // Remove trailing '?' if any
            return queryString ? `${queryString}` : "";
        });
        showcaseListings.viewModel.LinkToThisPage = ko.computed(function () {
            return (filterLessUrl + (filterLessUrl.indexOf("?") <= -1 ? "?" : "&") + showcaseListings.viewModel.FilterString()).replace("?&", "?").replace(/\?*$/, "");
        });
        showcaseListings.viewModel.LocationHrefUrl = ko.computed(() => {
            try {
                const filterString = showcaseListings.viewModel.FilterString().replace('?&', '?').replace(/\?*$/, "");
                if (!filterString) {
                    if (showcaseListings.viewModel.OriginalLocationHref().indexOf('?') <= -1) {
                        return showcaseListings.viewModel.OriginalLocationHref();
                    }
                    return showcaseListings.viewModel.OriginalLocationHref().substring(0, showcaseListings.viewModel.OriginalLocationHref().indexOf('?'));
                }
                // Build the query string by removing any starting question mark or ampersand from the "filterQueryString"
                const queryString = `?${filterString.replace(/\^?/, '').replace(/\^&/, '')}`;
                if (showcaseListings.viewModel.OriginalLocationHref().indexOf('?') <= -1) {
                    const finalUrl = `${showcaseListings.viewModel.OriginalLocationHref()}${queryString}`;
                    return finalUrl;
                }
                const strippedOriginalUrl = showcaseListings.viewModel.OriginalLocationHref().substring(0, showcaseListings.viewModel.OriginalLocationHref().indexOf('?'));
                const resultUrl = `${strippedOriginalUrl}${queryString}`;
                return resultUrl;
            }
            catch (error) {
                console.error(error);
                return showcaseListings.viewModel.LinkToThisPage();
            }
        });
        showcaseListings.viewModel.FiltersUsed = ko.computed(function () {
            return showcaseListings.viewModel.Filter() !== "" || showcaseListings.viewModel.SearchText() !== "" || showcaseListings.viewModel.AddressLat() != null || showcaseListings.viewModel.AddressLong() != null || showcaseListings.viewModel.PriceRange() !== "" || showcaseListings.viewModel.Neighborhoods() !== "" || showcaseListings.viewModel.BedroomRange() !== "" || showcaseListings.viewModel.BathroomRange() !== "" || showcaseListings.viewModel.ZipcodeClean() !== "" || (showcaseListings.viewModel.ManagementCompanyIDClean() != null && showcaseListings.viewModel.ManagementCompanyIDClean() !== "") || showcaseListings.viewModel.PolygonCoordinates() !== "";
        });
        showcaseListings.viewModel.PriceRangeIncreased = ko.computed(function () {
            if (!showcaseListings.viewModel.PriceRange())
                return null;
            const allPrices = showcaseListings.viewModel.ByUnit() ? unitPrices : roomPrices;
            return [Math.max(parseInt(showcaseListings.viewModel.PriceRange().split("-")[0]) - 100, allPrices[0]) + "-" + Math.min(parseInt(showcaseListings.viewModel.PriceRange().split("-")[1]) + 100, allPrices[allPrices.length - 1]), Math.max(parseInt(showcaseListings.viewModel.PriceRange().split("-")[0]) - 50, allPrices[0]) + "-" + Math.min(parseInt(showcaseListings.viewModel.PriceRange().split("-")[1]) + 50, allPrices[allPrices.length - 1])];
        });
        showcaseListings.viewModel.ShowSearchSuggestions = ko.computed(function () {
            return showcaseListings.viewModel.TotalRowCount() <= 4 && !showcaseListings.viewModel.Loading() && !showcaseListings.viewModel.Error();
        });
        showcaseListings.viewModel.TotalResultsDisplay = ko.computed(function () {
            const total = showcaseListings.viewModel.TotalRowCount();
            if (total <= 0)
                return "";
            return `(${total})`;
        });
        // Watch the filters for changes
        showcaseListings.viewModel.AddressText.subscribe(function () {
            showcaseListings.SetUserAddress();
        });
        showcaseListings.viewModel.AddressLat.subscribe(function () {
            showcaseListings.viewModel.FiltersChanged(true);
        });
        showcaseListings.viewModel.AddressLong.subscribe(function () {
            showcaseListings.viewModel.FiltersChanged(true);
        });
        showcaseListings.viewModel.TravelTime.subscribe(function () {
            if (showcaseListings.viewModel.AddressLat() != null && showcaseListings.viewModel.AddressLong() != null)
                showcaseListings.viewModel.FiltersChanged(true);
        });
        showcaseListings.viewModel.TravelBy.subscribe(function () {
            if (showcaseListings.viewModel.AddressLat() != null && showcaseListings.viewModel.AddressLong() != null)
                showcaseListings.viewModel.FiltersChanged(true);
        });
        showcaseListings.viewModel.SearchText.subscribe(function () {
            showcaseListings.viewModel.FiltersChanged(true);
        });
        showcaseListings.viewModel.Filter.subscribe(function () {
            showcaseListings.viewModel.FiltersChanged(true);
        });
        showcaseListings.viewModel.PriceRange.subscribe(function () {
            showcaseListings.viewModel.FiltersChanged(true);
        });
        showcaseListings.viewModel.ByUnit.subscribe(function () {
            if (showcaseListings.viewModel.PriceRange() !== "")
                showcaseListings.viewModel.PriceRange("");
            BindPriceSlider();
        });
        showcaseListings.viewModel.Neighborhoods.subscribe(function () {
            showcaseListings.viewModel.FiltersChanged(true);
        });
        showcaseListings.viewModel.BedroomRange.subscribe(function () {
            showcaseListings.viewModel.FiltersChanged(true);
        });
        showcaseListings.viewModel.BathroomRange.subscribe(function () {
            showcaseListings.viewModel.FiltersChanged(true);
        });
        showcaseListings.viewModel.Zipcode.subscribe(function (newValue) {
            showcaseListings.viewModel.FiltersChanged(true);
        });
        showcaseListings.viewModel.ManagementCompanyID.subscribe(function (newValue) {
            showcaseListings.viewModel.FiltersChanged(true);
        });
        showcaseListings.viewModel.PolygonCoordinates.subscribe(function () {
            showcaseListings.viewModel.FiltersChanged(true);
        });
        showcaseListings.viewModel.PriceMin.subscribe(function () {
            MobileUpdatePriceRange();
        });
        showcaseListings.viewModel.PriceMax.subscribe(function () {
            MobileUpdatePriceRange();
        });
        showcaseListings.viewModel.BedroomMin.subscribe(function () {
            MobileUpdateBedroomRange();
        });
        showcaseListings.viewModel.BedroomMax.subscribe(function () {
            MobileUpdateBedroomRange();
        });
        showcaseListings.viewModel.BathroomMin.subscribe(function () {
            MobileUpdateBathroomRange();
        });
        showcaseListings.viewModel.BathroomMax.subscribe(function () {
            MobileUpdateBathroomRange();
        });
        function MobileUpdatePriceRange() {
            const minEnd = $("#uxPriceMin option:first").val();
            const maxEnd = $("#uxPriceMax option:last").val();
            if (String(showcaseListings.viewModel.PriceMin()) === String(minEnd) && String(showcaseListings.viewModel.PriceMax()) === String(maxEnd))
                showcaseListings.viewModel.PriceRange("");
            else
                showcaseListings.viewModel.PriceRange(showcaseListings.viewModel.PriceMin() + "-" + showcaseListings.viewModel.PriceMax());
            $("#uxPriceMin option").each(function () {
                if (parseInt($(this).val()) <= parseInt(showcaseListings.viewModel.PriceMax()))
                    $(this).removeAttr("disabled");
                else
                    $(this).prop("disabled", "disabled");
            });
            $("#uxPriceMax option").each(function () {
                if (parseInt($(this).val()) >= parseInt(showcaseListings.viewModel.PriceMin()))
                    $(this).removeAttr("disabled");
                else
                    $(this).prop("disabled", "disabled");
            });
        }
        function MobileUpdateBedroomRange() {
            if (showcaseListings.viewModel.BedroomMin() === $("#uxBedroomMin option:first").val() && showcaseListings.viewModel.BedroomMax() === $("#uxBedroomMin option:last").val())
                showcaseListings.viewModel.BedroomRange("");
            else
                showcaseListings.viewModel.BedroomRange(showcaseListings.viewModel.BedroomMin() + "-" + showcaseListings.viewModel.BedroomMax());
            $("#uxBedroomMin option").each(function () {
                if (parseInt($(this).val()) <= parseInt(showcaseListings.viewModel.BedroomMax()))
                    $(this).removeAttr("disabled");
                else
                    $(this).prop("disabled", "disabled");
            });
            $("#uxBedroomMax option").each(function () {
                if (parseInt($(this).val()) >= parseInt(showcaseListings.viewModel.BedroomMin()))
                    $(this).removeAttr("disabled");
                else
                    $(this).prop("disabled", "disabled");
            });
        }
        function MobileUpdateBathroomRange() {
            if (showcaseListings.viewModel.BathroomMin() === $("#uxBathroomMin option:first").val() && showcaseListings.viewModel.BathroomMax() === $("#uxBathroomMin option:last").val())
                showcaseListings.viewModel.BathroomRange("");
            else
                showcaseListings.viewModel.BathroomRange(showcaseListings.viewModel.BathroomMin() + "-" + showcaseListings.viewModel.BathroomMax());
            $("#uxBathroomMin option").each(function () {
                if (parseInt($(this).val()) <= parseInt(showcaseListings.viewModel.BathroomMax()))
                    $(this).removeAttr("disabled");
                else
                    $(this).prop("disabled", "disabled");
            });
            $("#uxBathroomMax option").each(function () {
                if (parseInt($(this).val()) >= parseInt(showcaseListings.viewModel.BathroomMin()))
                    $(this).removeAttr("disabled");
                else
                    $(this).prop("disabled", "disabled");
            });
        }
        ko.computed(function () {
            if (showcaseListings.viewModel.FiltersChanged() && showcaseListings.viewModel.ReadyToLoadData()) {
                if (!filterEventTracked && globalThis.loaded) {
                    ils.trackMetric({ metricName: "Listing Page Filters Used", count: 1 });
                    //ga("send", "event", "FiltersUsed", "click", "1");
                    filterEventTracked = true;
                    if (lastSearchSeen)
                        IncrementNotifications();
                }
                // Change the URL to include the query string parameters so the user can share a link
                if (!isInitialLoad) {
                    LoadNewSet();
                }
            }
        });
        ko.computed(function () {
            const total = showcaseListings.viewModel.TotalRowCount();
            const loading = showcaseListings.viewModel.Loading();
            const priceRange = showcaseListings.viewModel.PriceRange();
            const ready = showcaseListings.viewModel.ReadyToLoadData();
            if (loading || total > 4 || !priceRange || !ready) {
                priceRangeAddsRequestId++;
                showcaseListings.viewModel.PriceRangeAdds([0, 0]);
                return;
            }
            const increased = showcaseListings.viewModel.PriceRangeIncreased();
            if (!increased)
                return;
            const requestId = ++priceRangeAddsRequestId;
            showcaseListings.viewModel.PriceRangeAdds([0, 0]);
            const counts = [null, null];
            const finish = function (index, added) {
                if (requestId !== priceRangeAddsRequestId)
                    return;
                counts[index] = added;
                if (counts[0] === null || counts[1] === null)
                    return;
                showcaseListings.viewModel.PriceRangeAdds(counts.slice());
            };
            const loadAddedCount = function (index) {
                $.ajax({
                    type: "POST",
                    url: globalThis.baseUrl + "TftServices/Showcase/ShowcaseWebMethods.asmx/LoadMoreItems",
                    data: GetNextPageRequestJSON(1, increased[index]),
                    contentType: "application/json; charset=utf-8",
                    dataType: "json",
                    success: function (data) {
                        const newRowCount = data.d.length > 0 ? data.d[0].TotalRowCount : 0;
                        finish(index, Math.max(0, newRowCount - showcaseListings.viewModel.TotalRowCount()));
                    },
                    error: function () {
                        finish(index, 0);
                    }
                });
            };
            // Index 0 is the $100 widen; index 1 is the $50 widen.
            loadAddedCount(0);
            loadAddedCount(1);
        }).extend({ throttle: 100 });
        async function LoadNewSet() {
            const generation = ++loadGeneration;
            // Cancel a previous, still-in-flight map pins request - a new filter tap makes it stale.
            if (mapPinsAbortController) {
                mapPinsAbortController.abort();
            }
            mapPinsAbortController = new AbortController();
            const mapPinsSignal = mapPinsAbortController.signal;
            showcaseListings.viewModel.PageNumber(1);
            // The visible list (paged) and the map's pins (every matching result, unpaginated) are
            // fetched from two independent endpoints, in parallel - neither one blocks on, or feeds,
            // the other. This replaces the old approach of looping through LoadMoreItems pages and
            // eagerly rendering every result into the visible list right on the filter tap, purely so
            // the map would have a pin for every result - that loop was a major main-thread INP hit.
            const listLoadPromise = LoadNextSet();
            const mapPinsPromise = LoadMapPins(mapPinsSignal);
            await listLoadPromise;
            if (generation !== loadGeneration) {
                await mapPinsPromise;
                return;
            }
            if (isInitialLoad || showcaseListings.viewModel.LazyLoadedListings().length < 1) {
                await LazyLoadNextPage();
            }
            isInitialLoad = false;
            showcaseListings.viewModel.ReadyToLoadData(true);
            await mapPinsPromise;
        }
        showcaseListings.LoadNewSet = LoadNewSet;
        /**
         * Fetches a lightweight (map-marker-only) payload for every showcase item matching the current
         * filters, in a single unpaginated request, and places a pin for each one. Runs independently
         * of the paged visible-list load (see LoadNewSet) and never touches viewModel.Listings.
         */
        async function LoadMapPins(signal) {
            if (!(showMap && mapsAreInitialized) || showcaseListings.map == null) {
                return;
            }
            // Address/travel prefiltered pages need lat/long before the pin request, otherwise the
            // server returns an unscoped result set (many more pins than the filtered list count).
            await EnsureAddressCoordinatesForMapPins();
            if (signal.aborted)
                return;
            showcaseListings.clearMarkers();
            try {
                const response = await fetch(globalThis.baseUrl + "TftServices/Showcase/ShowcaseWebMethods.asmx/LoadMapPins", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json; charset=utf-8",
                        "X-ILS-Request": "1"
                    },
                    body: GetMapPinsRequestJSON(),
                    signal
                });
                const data = await response.json();
                const pins = (data && data.d) ? data.d : [];
                if (pins.length === 0) {
                    // By-apartment and by-room searches share this path. With no pins,
                    // leave the map on the market instead of fitting an empty bounds.
                    showcaseListings.centerOnNeighborhood();
                    return;
                }
                for (let i = 0; i < pins.length; i++) {
                    showcaseListings.codeAddress(pins[i], i === pins.length - 1);
                }
            }
            catch (error) {
                if (error && error.name === "AbortError") {
                    return; // Superseded by a newer filter tap - nothing more to do.
                }
                console.error(`Error fetching map pins: ${error}`);
            }
        }
        /**
         * Ensures AddressLat/Long are populated when an address text filter is active. Prefers values
         * already set (including server-emitted prefilter coords); otherwise waits for browser geocode.
         */
        async function EnsureAddressCoordinatesForMapPins() {
            const addressText = (showcaseListings.viewModel.AddressText() || "").trim();
            if (!addressText)
                return;
            if (showcaseListings.viewModel.AddressLat() != null && showcaseListings.viewModel.AddressLong() != null)
                return;
            await showcaseListings.SetUserAddressAsync();
        }
        function ReplaceQuotes(text) {
            return text.replace(/\"/g, "");
        }
        function FormatPhone(phone) {
            if (!phone || phone.length < 10 || isNaN(phone))
                return phone;
            return `(${phone.substring(0, 3)}) ${phone.substring(3, 6)}-${phone.substring(6)}`;
        }
        showcaseListings.FormatPhone = FormatPhone;
        function FormatFloorPlanTypes(types) {
            if (!types)
                return types;
            const typeArray = types.split(",");
            var consecutive = true;
            for (let i = 1; i < typeArray.length; i++) {
                if (parseInt(typeArray[i]) !== (parseInt(typeArray[i - 1]) + 1))
                    consecutive = false;
            }
            return (consecutive ? (typeArray[0] === typeArray[typeArray.length - 1] ? (typeArray[0] === 0 ? "Studios" : typeArray[0] + " BR") : `${typeArray[0] === 0 ? "Studio" : typeArray[0]} to ${typeArray[typeArray.length - 1]} BR`) : `${types.replace(/,/g, ", ").replace(/,([^,]*)$/, " and $1")} BR`);
        }
        showcaseListings.FormatFloorPlanTypes = FormatFloorPlanTypes;
        function GetTitleClass(Title) {
            return Title.length >= 20 ? `long${Title.length >= 23 ? " super-long" : ""}` : Title.length >= 18 ? "long-mobile" : "";
        }
        showcaseListings.GetTitleClass = GetTitleClass;
        function GetImage(Image, ABTestImage, preset) {
            return `${globalThis.imageDomain}uploads/images/${ABTestImage && abShowAlternate ? ABTestImage : Image}${preset ? preset : `?preset=community${ABTestImage && abShowAlternate ? "&mode=crop" : ""}`}`;
        }
        showcaseListings.GetImage = GetImage;
        function ClearFilter(attributeID) {
            GetFilterByID(attributeID).ClearFilter();
        }
        showcaseListings.ClearFilter = ClearFilter;
        function ClearTravelTimeFilter() {
            showcaseListings.viewModel.ReadyToLoadData(false);
            showcaseListings.viewModel.AddressLat(null);
            showcaseListings.viewModel.AddressLong(null);
            showcaseListings.viewModel.TravelTime("30");
            showcaseListings.viewModel.TravelBy("drive");
            showcaseListings.viewModel.AddressText("");
            showcaseListings.viewModel.ReadyToLoadData(true);
        }
        showcaseListings.ClearTravelTimeFilter = ClearTravelTimeFilter;
        function ClearManagementCompany() {
            showcaseListings.viewModel.ManagementCompanyID("All");
        }
        showcaseListings.ClearManagementCompany = ClearManagementCompany;
        function ClearPriceFilter() {
            if (breakpoint() === "mobile" && !isTablet()) {
                ClearMobileDropdownFilter($("#uxPriceMin").parent());
            }
            const sliderElement = $("#uxPriceRangeSlider");
            if (breakpoint() !== "mobile" || isTablet()) {
                ClearRangeSlider(sliderElement);
                sliderElement.find(".handle-text:first").html(`$${sliderElement.slider("option", "min")}`);
                sliderElement.find(".handle-text:last").html(`$${sliderElement.slider("option", "max")}`);
            }
            // PriceMin/PriceMax stay on the widened range after Increase Price. Reset reads them
            // back into PriceRange, so clear both to the dropdown ends before that runs.
            showcaseListings.viewModel.PriceMax(String($("#uxPriceMax option:last").val()));
            showcaseListings.viewModel.PriceMin(String($("#uxPriceMin option:first").val()));
            showcaseListings.viewModel.PriceRange("");
        }
        showcaseListings.ClearPriceFilter = ClearPriceFilter;
        function ClearBedroomFilter() {
            if (breakpoint() === "mobile" && !isTablet()) {
                ClearMobileDropdownFilter($("#uxBedroomMin").parent());
                return;
            }
            const sliderElement = $("#uxBedroomRangeSlider");
            ClearRangeSlider(sliderElement);
            sliderElement.find(".handle-text:first").html(FormatBedroomText(sliderElement.slider("option", "min")));
            sliderElement.find(".handle-text:last").html(FormatBedroomText(sliderElement.slider("option", "max")));
            showcaseListings.viewModel.BedroomRange("");
        }
        showcaseListings.ClearBedroomFilter = ClearBedroomFilter;
        function ClearBathroomFilter() {
            if (breakpoint() === "mobile" && !isTablet()) {
                ClearMobileDropdownFilter($("#uxBathroomMin").parent());
                return;
            }
            const sliderElement = $("#uxBathroomRangeSlider");
            ClearRangeSlider(sliderElement);
            sliderElement.find(".handle-text:first").html(sliderElement.slider("option", "min"));
            sliderElement.find(".handle-text:last").html(sliderElement.slider("option", "max"));
            showcaseListings.viewModel.BathroomRange("");
        }
        showcaseListings.ClearBathroomFilter = ClearBathroomFilter;
        function ClearNeighborhoodFilter() {
            $("input[id*=uxNeighborhoodCheckBoxList]").each(function () {
                ClearCheckBox($(this));
            });
            showcaseListings.viewModel.Neighborhoods("");
        }
        showcaseListings.ClearNeighborhoodFilter = ClearNeighborhoodFilter;
        function ClearSearchText() {
            showcaseListings.viewModel.SearchText("");
        }
        showcaseListings.ClearSearchText = ClearSearchText;
        function ClearZipcodeFilter() {
            showcaseListings.viewModel.Zipcode("All");
        }
        showcaseListings.ClearZipcodeFilter = ClearZipcodeFilter;
        function ClearMapAreaFilter() {
            {
                if (showcaseListings.polygon)
                    showcaseListings.polygon.setMap(null);
                if (showcaseListings.polyline)
                    showcaseListings.polyline.setMap(null);
                showcaseListings.viewModel.PolygonCoordinates("");
            }
        }
        showcaseListings.ClearMapAreaFilter = ClearMapAreaFilter;
        function UpdatePriceRange(index) {
            const value1 = parseInt(showcaseListings.viewModel.PriceRangeIncreased()[index].split("-")[0]);
            const value2 = parseInt(showcaseListings.viewModel.PriceRangeIncreased()[index].split("-")[1]);
            showcaseListings.viewModel.PriceRangeAdds([0, 0]);
            const sliderElement = $("#uxPriceRangeSlider");
            try {
                // Attempt to set the slider values - desktop
                sliderElement.slider("values", [value1, value2]);
                sliderElement.find(".handle-text:first").html(`$${value1}`);
                sliderElement.find(".handle-text:last").html(`$${value2}`);
            }
            catch (error) {
                // If slider fails, fall back to setting data attributes - mobile
                sliderElement.data('value1', value1);
                sliderElement.data('value2', value2);
                sliderElement.attr('data-value1', value1);
                sliderElement.attr('data-value2', value2);
            }
            priceSliderUpdateFilter(sliderElement);
        }
        showcaseListings.UpdatePriceRange = UpdatePriceRange;
        ko.bindingHandlers.afterRenderWireups = {
            // ReSharper disable once UnusedParameter
            update: function (element, valueAccessor, allBindingsAccessor) {
                ko.utils.unwrapObservable(valueAccessor());
                if (!showcaseListings.viewModel.ReadyToLoadData())
                    return;
                if (showMap) {
                    $(element).off("mouseenter.showcaseMapHover").on("mouseenter.showcaseMapHover", "li", function () {
                        // Prevent immediate map zoom when page loads with mouse over showcase item
                        if (!allowMapHoverInteraction)
                            return;
                        // List order (featured/super icons shuffled to the top) does not match
                        // LoadMapPins order, so look up the pin by ShowcaseItemID.
                        const itemId = $(this).find("a.community").attr("data-id");
                        if (typeof showcaseListings.showInfoWindowByItemId === "function")
                            showcaseListings.showInfoWindowByItemId(itemId, true);
                    });
                }
            }
        };
        /**
         * Loads the next set of showcase items into the view model that shows the listings.
         *
         * @param callbackAfterSuccess A callback function to be executed after the success of loading the items.
         */
        async function LoadNextSet() {
            globalThis.currentFilter = GetFilterJSONString();
            // If this is the initial page load, we already have the showcase items from the server-side so no need to go fetch them again 
            if (isInitialLoad) {
                // The globalThis.initialItems is defined in the NewListingPage.ascx.cs code behind around line 522 and then "rendered"
                // at the bottom of the NewListingPage.ascx web form page
                await success_method({ d: initialItems });
                showcaseListings.viewModel.Loading(false);
                return;
            }
            try {
                const response = await fetch(globalThis.baseUrl + "TftServices/Showcase/ShowcaseWebMethods.asmx/LoadMoreItems", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json; charset=utf-8",
                        "X-ILS-Request": "1"
                    },
                    body: GetNextPageRequestJSON(showcaseListings.viewModel.PageNumber(), showcaseListings.viewModel.PriceRange())
                });
                const data = await response.json();
                success_method(data);
            }
            catch (error) {
                if (showcaseListings.viewModel.PolygonCoordinates())
                    showcaseListings.viewModel.Error("Please make sure that your shape does not intersect itself.");
                else
                    showcaseListings.viewModel.Error("");
                showcaseListings.viewModel.TotalRowCount(0);
                showcaseListings.viewModel.Listings([]);
                showcaseListings.viewModel.Loading(false);
                isInitialLoad = false;
            }
            async function success_method(data) {
                const results = data.d;
                // If it's a subsequent load, we need to clear the cache key so that the next time we load the data, we get a fresh set of results
                resultsCacheKey = '';
                showcaseListings.viewModel.Error(null);
                if (results.length === 0) {
                    showcaseListings.viewModel.TotalRowCount(0);
                    showcaseListings.viewModel.Listings(results);
                    showcaseListings.viewModel.FiltersChanged(false);
                    showcaseListings.viewModel.Loading(false);
                    return;
                }
                else {
                    showcaseListings.viewModel.TotalRowCount(results[0].TotalRowCount);
                }
                showcaseListings.viewModel.Listings(results);
                $(".tab-pane.results").addClass("globalThis.loaded");
                if (!globalThis.loaded) {
                    globalThis.loaded = true;
                    if (globalThis.showcaseItemID != null && globalThis.showcaseItemID.toString() !== "") {
                        let found = false;
                        for (let i = 0; i < showcaseListings.viewModel.Listings().length; i++) {
                            if (showcaseListings.viewModel.Listings()[i].ShowcaseItemID === globalThis.showcaseItemID) {
                                found = true;
                                break;
                            }
                        }
                        if (!found)
                            $(".communities").html(`${$(".communities").html()}<a style="display: none;" class="community" data-id="${globalThis.showcaseItemID}" href="${detailsLinkBase}?id=${globalThis.showcaseItemID}&">`);
                        $(`.communities a[data-id=${parseInt(globalThis.showcaseItemID.toString())}]`).on('click', communityClick).trigger('click');
                    }
                }
                if (breakpoint() !== "mobile" || isTablet())
                    setTimeout(function () { $("#filter-categories").jcarousel("reload"); }, 100);
                showcaseListings.viewModel.FiltersChanged(false);
                showcaseListings.viewModel.Loading(false);
                // On mobile the initial paint can keep the server-rendered list (ShowKnockoutView
                // false). Any later load - including filter changes while the Refine panel is open -
                // must switch to the Knockout list. Otherwise TotalRowCount updates (e.g. "Show
                // Results (16)") while the DOM still shows the original SSR results.
                if (!isInitialLoad || breakpoint() !== "mobile" || isTablet()) {
                    showcaseListings.viewModel.ShowKnockoutView(true);
                }
                // Map markers are placed separately by LoadMapPins(), run in parallel with this list
                // load for the same filter change - see LoadNewSet().
                if (ko.utils.arrayFirst(showcaseListings.viewModel.Listings(), function (item) { return item.ABTestImage && item.ABTestImage !== ""; }) != null) {
                    const checkAbImageTimeout = setTimeout(function () {
                        CheckIfABImageInView();
                        clearTimeout(checkAbImageTimeout);
                    }, 500);
                }
                var iconTimeout = setTimeout(function () {
                    if (shouldToggleIcons) {
                        $(".featured-icon").removeClass("ilsicon ilsicon-star-favorite in-corner-rounded");
                        $(".featured-icon").html(featuredIconText);
                        $(".featured-icon").addClass("in-corner-spotlight");
                    }
                    HookupCommunityEventHandlers();
                    clearTimeout(iconTimeout);
                }, 250);
            }
        }
        showcaseListings.LoadNextSet = LoadNextSet;
        function CheckIfABImageInView() {
            if ((breakpoint() === "mobile" && !isTablet() && $(".mobile-tab.results.active").length === 0) || showcaseListings.viewModel.Listings().length === 0)
                return;
            var yValueToCheck = breakpoint() === "mobile" && !isTablet()
                ? $(window).scrollTop() + $(window).height()
                : $(".filters-results").height();
            document.querySelectorAll(".filters-results .community[data-has-ab]").forEach(function (element) {
                if (element.offsetTop <= yValueToCheck && trackedABViews.indexOf(element.dataset.id) === -1) {
                    trackedABViews.push(element.getAttribute("data-id"));
                    ils.trackABImageImpression({
                        communityId: parseInt(element.dataset.id),
                        imageName: `${abMainImageName}View`,
                        test_context: (abShowAlternate ? "alternate" : "main"),
                        communityName: element.dataset.title,
                    });
                    //ga("send", "event", `${abMainImageName}View`, (abShowAlternate ? "alternate" : "main"), element.getAttribute("data-id"));
                }
            });
        }
        function GetFilterJSONString() {
            return ko.toJSON([resultsCacheKey, showcaseListings.viewModel.PageSize(), showcaseListings.viewModel.Filter(), showcaseListings.viewModel.AddressLat(), showcaseListings.viewModel.AddressLong(), showcaseListings.viewModel.TravelTime(), showcaseListings.viewModel.TravelBy(), showcaseListings.viewModel.SearchText(), showcaseListings.viewModel.PriceRange(), showcaseListings.viewModel.ByUnit(), showcaseListings.viewModel.Neighborhoods(), showcaseListings.viewModel.BedroomRange(), showcaseListings.viewModel.BathroomRange(), showcaseListings.viewModel.ZipcodeClean(), showcaseListings.viewModel.ManagementCompanyIDClean(), showcaseListings.viewModel.PolygonCoordinates()]);
        }
        function GetNextPageRequestJSON(pageNumber, priceRange) {
            return `{pageSize: ${showcaseListings.viewModel.PageSize()}, pageNumber: ${pageNumber}, filters: "${showcaseListings.viewModel.Filter()}", addressLat: ${showcaseListings.viewModel.AddressLat()}, addressLong: ${showcaseListings.viewModel.AddressLong()}, travelTime: ${showcaseListings.viewModel.TravelTime()}, travelBy: "${showcaseListings.viewModel.TravelBy()}", searchText: "${showcaseListings.viewModel.SearchText()}", priceRange: "${priceRange}", priceByUnit: ${showcaseListings.viewModel.ByUnit()}, neighborhoods: "${showcaseListings.viewModel.Neighborhoods()}", bedroomRange: "${showcaseListings.viewModel.BedroomRange()}", bathroomRange: "${showcaseListings.viewModel.BathroomRange()}", zipcode: ${showcaseListings.viewModel.ZipcodeClean() !== "" ? `"${showcaseListings.viewModel.ZipcodeClean()}"` : null}, managementCompanyID: ${showcaseListings.viewModel.ManagementCompanyIDClean() === "" ? null : showcaseListings.viewModel.ManagementCompanyIDClean()}, polygonCoordinates: "${showcaseListings.viewModel.PolygonCoordinates()}", cacheKeyRandomString: "${cacheKeyRandomString}", filterString: "${showcaseListings.viewModel.FilterString()}", resultsCacheKey: "${resultsCacheKey}"}`;
        }
        function GetMapPinsRequestJSON() {
            return `{filters: "${showcaseListings.viewModel.Filter()}", addressLat: ${showcaseListings.viewModel.AddressLat()}, addressLong: ${showcaseListings.viewModel.AddressLong()}, travelTime: ${showcaseListings.viewModel.TravelTime()}, travelBy: "${showcaseListings.viewModel.TravelBy()}", searchText: "${showcaseListings.viewModel.SearchText()}", priceRange: "${showcaseListings.viewModel.PriceRange()}", priceByUnit: ${showcaseListings.viewModel.ByUnit()}, neighborhoods: "${showcaseListings.viewModel.Neighborhoods()}", bedroomRange: "${showcaseListings.viewModel.BedroomRange()}", bathroomRange: "${showcaseListings.viewModel.BathroomRange()}", zipcode: ${showcaseListings.viewModel.ZipcodeClean() !== "" ? `"${showcaseListings.viewModel.ZipcodeClean()}"` : null}, managementCompanyID: ${showcaseListings.viewModel.ManagementCompanyIDClean() === "" ? null : showcaseListings.viewModel.ManagementCompanyIDClean()}, polygonCoordinates: "${showcaseListings.viewModel.PolygonCoordinates()}", cacheKeyRandomString: "${cacheKeyRandomString}"}`;
        }
        async function LazyLoadNextPage() {
            if (!showcaseListings.viewModel.NextEnabled() || showcaseListings.viewModel.Listings().length >= showcaseListings.viewModel.TotalRowCount()) {
                // Clear out the array so that the scrolling doesn't keep trying to load the same final set of items into view
                showcaseListings.viewModel.LazyLoadedListings([]);
                return;
            }
            var thisFilter = GetFilterJSONString();
            try {
                const response = await fetch(globalThis.baseUrl + "TftServices/Showcase/ShowcaseWebMethods.asmx/LoadMoreItems", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json; charset=utf-8",
                        "X-ILS-Request": "1"
                    },
                    body: GetNextPageRequestJSON(showcaseListings.viewModel.PageNumber() + 1, showcaseListings.viewModel.PriceRange())
                });
                const data = await response.json();
                lazy_success_method(data);
            }
            catch (error) {
                console.error('Error fetching more showcase items:', error);
            }
            function lazy_success_method(data) {
                const results = data.d;
                showcaseListings.viewModel.LazyLoadedListings(results);
            }
        }
        function EscapeFilter(filterValue) {
            return filterValue.toLowerCase().replace(/\,/g, "[COMMA]").replace(/\:/g, "[COLON]").replace(/\|/g, "[PIPE]").replace(/\</g, "[LESSTHAN]").replace(/\>/g, "[GREATERTHAN]");
        }
        function CleanupFilter(filterValue) {
            return filterValue.toLowerCase().replace(/\,*$/, "").replace(/\,\,/, ",").replace(/^\,/, "");
        }
        function GetAttributeID(element) {
            return element.prev();
        }
        function GetFeaturedIconCommunities() {
            try {
                $.ajax({
                    type: "POST",
                    url: globalThis.baseUrl + "api/showcase/load-featured-icons",
                    contentType: "application/json; charset=utf-8",
                    dataType: "json",
                    success: function (data) {
                        const featuredIconCommunities = [];
                        for (let i = 0; i < data.d.length; i++) {
                            if (data.d[i].IsFeaturedIcon) {
                                featuredIconCommunities.push(data.d[i].ShowcaseItemID);
                            }
                        }
                        showcaseListings.viewModel.FeaturedIcons(featuredIconCommunities);
                    }
                });
            }
            catch (e) {
                console.error(e);
                console.log("Previous exception was caught and swallowed");
            }
        }
        document.addEventListener('DOMContentLoaded', async function () {
            // Delay enabling map hover interaction to prevent immediate zoom when page loads
            // with mouse pointer already over a showcase item
            setTimeout(function () {
                allowMapHoverInteraction = true;
            }, 800);
            showcaseListings.viewModel.OriginalLocationHref(window.location.href);
            GetFeaturedIconCommunities();
            var trackedImpressions = [];
            $("[data-impressions]").on('click', function () {
                const impressions = $(this).data("impressions");
                if ($.inArray(impressions, trackedImpressions) === -1) {
                    $.ajax({
                        type: "POST",
                        url: globalThis.baseUrl + "TftServices/Showcase/ShowcaseWebMethods.asmx/TrackAttributeImpression",
                        data: `{ showcaseAttributeValueID: [${impressions}]}`,
                        contentType: "application/json; charset=utf-8",
                        dataType: "json"
                    });
                    trackedImpressions.push(impressions);
                }
            });
            $("input[id*=uxFilterAddress], input[id*=uxSearchText]").keydown(function (event) {
                if (event.keyCode === 13)
                    $(this).trigger("change").trigger("blur");
                return event.keyCode !== 13;
            });
            //Begin Filters
            $(".filters input[id*=uxFilterRadioButtonList]").on('click', function (e) {
                if ($(this).val() !== "") {
                    const attributeID = GetAttributeID($(this).parents(".radiobuttons"));
                    const currentFilterItem = GetFilterByID(attributeID.val());
                    if ($(this).val() !== "all")
                        currentFilterItem.Value(EscapeFilter($(this).val()));
                    else
                        currentFilterItem.Value("");
                    e.stopPropagation();
                }
            });
            $(".filters .checkboxes li").on('click', function (e) {
                if ($(e.target).is("li"))
                    $(e.target).find("input").trigger('click');
            });
            $(".filters input[id*=CheckBoxList]").on('click', function () {
                var isNeighborhoodFilter = false;
                var isRegionFilter = false;
                if ($(this).parents("[id*=uxRegionCheckBoxList]").length > 0)
                    isRegionFilter = true;
                if ($(this).parents("[id*=uxNeighborhoodCheckBoxList]").length > 0)
                    isNeighborhoodFilter = true;
                var custom = isNeighborhoodFilter || isRegionFilter;
                var attributeID = GetAttributeID($(this).parents(".checkboxes"));
                var currentFilter = GetFilterByID(attributeID.val());
                if ($(this).is(":checked")) {
                    var tempFilters = "";
                    var tempNeighborhoods = "";
                    $(this).parents(".checkboxes").find(":checkbox:checked").each(function () {
                        if (!custom)
                            tempFilters += EscapeFilter($(this).siblings().text()) + "[yes],";
                        else if (isNeighborhoodFilter)
                            tempNeighborhoods += $(this).parent().data("id") + ",";
                        else if (isRegionFilter)
                            tempNeighborhoods += $(this).parent().find("[type=hidden]").val() + ",";
                    });
                    if (!custom)
                        currentFilter.Value(CleanupFilter(tempFilters));
                    else
                        showcaseListings.viewModel.Neighborhoods(tempNeighborhoods.replace(/\,*$/, ""));
                    if (isRegionFilter) {
                        let neighborhoodIDs = $(this).parent().find("[type=hidden]").val().split(",");
                        for (let i = 0; i < neighborhoodIDs.length; i++) {
                            $(`[id*=uxNeighborhoodCheckBoxList] span[data-id='${neighborhoodIDs[i]}'] input`).prop("checked", true);
                        }
                    }
                }
                else {
                    var thisLabel = $(`label[for=${$(this).attr("id")}]`);
                    var labelText = isNeighborhoodFilter ? ($(this).parent().data("id") ? $(this).parent().data("id").toString() : null) : thisLabel.text();
                    if (!custom)
                        currentFilter.Value(CleanupFilter(currentFilter.Value().toLowerCase().replace(EscapeFilter(labelText.toLowerCase()) + "[yes]", "")));
                    else if (isNeighborhoodFilter)
                        showcaseListings.viewModel.Neighborhoods(showcaseListings.viewModel.Neighborhoods().toLowerCase().replace(labelText.toLowerCase(), "").replace(/^\,/, "").replace(/\,*$/, "").replace(/\,\,/, ","));
                    else if (isRegionFilter)
                        showcaseListings.viewModel.Neighborhoods(showcaseListings.viewModel.Neighborhoods().toLowerCase().replace($(this).parent().find("[type=hidden]").val().toLowerCase(), "").replace(/\,*$/, "").replace(/\,\,/, ","));
                    $(this).siblings().removeClass("focused");
                    if (isRegionFilter) {
                        let neighborhoodIDs = $(this).parent().find("[type=hidden]").val().split(",");
                        for (let i = 0; i < neighborhoodIDs.length; i++) {
                            $(`[id*=uxNeighborhoodCheckBoxList] span[data-id='${neighborhoodIDs[i]}'] input`).prop("checked", false);
                        }
                    }
                }
            });
            $(".filters [id*=uxFilterDropDown]").change(function () {
                const attributeID = GetAttributeID($(this));
                const currentFilter = GetFilterByID(attributeID.val());
                if ($(this).val() === "all")
                    currentFilter.Value("");
                else
                    currentFilter.Value(EscapeFilter($(this).val()));
            });
            $(".filter-reset").on('click', function () {
                showcaseListings.viewModel.ReadyToLoadData(false);
                showcaseListings.viewModel.ByUnit(byUnitDefault === true);
                for (let i = 0; i < showcaseListings.viewModel.FilterList().length; i++) {
                    showcaseListings.viewModel.FilterList()[i].Value("");
                }
                ClearPriceFilter();
                ClearBedroomFilter();
                ClearBathroomFilter();
                $("[data-slider]").each(function () {
                    if ($(this).data("range"))
                        ClearRangeSlider($(this));
                    else
                        ClearSlider($(this));
                });
                $(".filters [id*=uxFilterDropDown]").each(function () {
                    ClearListBoxOrDropdown($(this));
                });
                $(".filters [id*=uxFilterRadioButtonList]").each(function () {
                    ClearRadioButtonList($(this));
                });
                $(".filters input[id*=uxRadioButtons]").each(function () {
                    ClearRadioButton($(this));
                });
                $(".filters :checkbox").each(function () {
                    ClearCheckBox($(this));
                });
                ClearSearchText();
                showcaseListings.viewModel.PriceRange("");
                ClearRegionFilter();
                ClearNeighborhoodFilter();
                showcaseListings.viewModel.BedroomRange("");
                showcaseListings.viewModel.BathroomRange("");
                ClearZipcodeFilter();
                ClearManagementCompany();
                ClearMapAreaFilter();
                ClearTravelTimeFilter();
                showcaseListings.viewModel.ReadyToLoadData(true);
                history.pushState(null, null, showcaseListings.viewModel.LocationHrefUrl());
                MobileUpdatePriceRange();
                return false;
            });
            function copyFilterLink(isMobile, jqElem) {
                if (!navigator.clipboard) {
                    alert("Cannot copy the search link. Your browser doesn't support it. Please manually copy the URL in the browser's address bar instead.");
                    return false;
                }
                const originalTitle = jqElem.attr('title');
                const originalHtml = jqElem.html();
                jqElem.attr('title', '');
                navigator.clipboard.writeText(showcaseListings.viewModel.LocationHrefUrl())
                    .then(() => {
                    jqElem.html(`<span class="ilsicon ilsicon-copy"></span>&nbsp;Copied!`);
                });
                var destroyTimeout = setTimeout(() => {
                    jqElem.attr('title', originalTitle);
                    jqElem.html(originalHtml);
                    clearTimeout(destroyTimeout);
                }, 2250);
                return false;
            }
            $(".copy-filter-link").on('click', function () {
                return copyFilterLink(false, $(this));
            });
            $(".copy-filter-link-mobile").on('click', function () {
                return copyFilterLink(true, $(this));
            });
            // If we're on a desktop, we need to bind the sliders, load the map scripts, and ensure the communities are loaded correctly
            if (breakpoint() !== "mobile" || isTablet()) {
                BindPriceSlider();
                BindBedroomSlider();
                BindBathroomSlider();
                ils.loadMapScripts(async function () {
                    await finalizeInitialLoad();
                });
            }
            // Otherwise we simply pre-load the map scripts and make sure the communities are loaded correctly
            else {
                showcaseListings.viewModel.ShowKnockoutView(true);
                ils.loadMapScripts(async function () {
                    showMap = false;
                    await finalizeInitialLoad();
                    loadingMaps = false;
                    isInitialLoad = false;
                    showMap = true;
                });
                showcaseListings.viewModel.MobileFilterPendingRefresh(true);
            }
            $(".link-to-page").on('click', function () {
                $(this).trigger('select');
                $(this).on('mouseup', function () {
                    $(this).off("mouseup");
                    return false;
                });
            });
            showcaseListings.viewModel.ByUnit(byUnit === true);
            ko.applyBindings(showcaseListings.viewModel);
            $("[data-slider]").each(function () {
                var sliderElement = $(this);
                const values = sliderElement.data("values");
                var range = $(this).data("range");
                if (range == null)
                    range = false;
                var value1 = $(this).data("value1") ? $(this).data("value1") : values[0];
                var value2 = $(this).data("value2") ? $(this).data("value2") : values[values.length - 1];
                $(this).removeAttr("data-values").removeAttr("data-value1").removeAttr("data-value2");
                sliderElement.slider({
                    range: range,
                    min: values[0],
                    max: values[values.length - 1],
                    values: [value1, value2],
                    create: function (event, ui) {
                        if (sliderElement.find(".handle-text").length === 0)
                            sliderElement.find(".ui-slider-handle").append('<span class="handle-text"></span>');
                        sliderElement.find(".handle-text:first").html(value1);
                        if (range) {
                            sliderElement.find(".handle-text:last").html(value2);
                            sliderElement.find(".ui-slider-handle:last").addClass("reverse");
                        }
                        UnstackSliderLabels(sliderElement.find(".ui-slider-handle:first"), value1, value2);
                        if (range)
                            rangeSliderUpdateFilter(sliderElement);
                        else
                            sliderUpdateFilter(sliderElement);
                    },
                    slide: function (event, ui) {
                        const handle = $(ui.handle);
                        handle.find(".handle-text").html(ui.value.toString());
                        if (range)
                            UnstackSliderLabels(handle, ui.values[0], ui.values[1]);
                    },
                    stop: function (event, ui) {
                        if (range)
                            rangeSliderUpdateFilter(sliderElement);
                        else
                            sliderUpdateFilter(sliderElement);
                    }
                });
            });
            $(".add-tooltip").tooltip();
            $(window).on("resize", function () {
                globalThis.mapLoaded = false;
                ThingsToDoOnResize();
            });
            ThingsToDoOnResize();
            HookupCommunityEventHandlers();
            if ($("#prefiltered-content").height() < 115)
                $(".expander").hide();
            $(".collapser").on('click', function () {
                $("#prefiltered-content").hide();
                $(".showcase-title").outerWidth("");
                $("#prefiltered-content").removeClass("mid");
                $(".showcase-title").addClass("minimized");
                $(this).hide();
                $(".expander").show();
                return false;
            });
            $(".expander").on('click', function () {
                $(".showcase-title").removeClass("minimized");
                SetTitlePosition();
                $("#prefiltered-content").removeClass("mid").slideDown("slow");
                $(this).hide();
                $(".collapser").show();
                return false;
            });
            var trackedAdViews = [];
            $("#filter-categories").on("click", "li", function (e) {
                $(".filters-results").addClass("advanced");
                if ($(this).hasClass("active"))
                    HideActiveFilterPanel();
                else {
                    $(".filter-tabs .filter-tab:visible").slideToggle();
                    const tabToOpen = $($(this).find("a").attr("href"));
                    tabToOpen.slideToggle(400, function () { if (breakpoint() !== "mobile" || isTablet())
                        $("#filter-categories").jcarousel("reload"); });
                    const adToTrack = tabToOpen.find(".advertisement");
                    if (adToTrack.length > 0 && $.inArray(adToTrack.data("id"), trackedAdViews) === -1) {
                        TrackAdViewed(adToTrack);
                        trackedAdViews.push(adToTrack.data("id"));
                    }
                    $(this).siblings(".active").removeClass("active");
                    $(this).toggleClass("active");
                }
                e.preventDefault();
            });
            $(".close-filter").on('click', function () {
                return HideActiveFilterPanel();
            });
            function HideActiveFilterPanel() {
                $("#filter-categories li.active").removeClass("active");
                $(".filter-tabs .filter-tab:visible").slideToggle(400, function () { if (breakpoint() !== "mobile" || isTablet())
                    $("#filter-categories").jcarousel("reload"); });
                $(".filters-results").removeClass("advanced");
                return false;
            }
            $(".scroll-filters").on('click', function () {
                $(".filters-results").animate({ scrollTop: 0 });
            });
            if (breakpoint() === "mobile" && !isTablet()) {
                $(window).on('scroll', function () {
                    if ($(".showcase-title").offset().top + $(".showcase-title").outerHeight(true) <= $(window).scrollTop()) {
                        $(".filters-results").css("margin-top", $(".showcase-tabs").outerHeight(true));
                        $(".showcase-tabs").addClass("fix-top");
                    }
                    else {
                        $(".filters-results").css("margin-top", 0);
                        $(".showcase-tabs").removeClass("fix-top");
                    }
                    CheckIfABImageInView();
                });
                $("#filter-categories li:first").trigger('click');
                $("#attrcategory-traveltime").append($(".travel-time"));
            }
            else {
                $("#travelCarousel").remove();
            }
            window.addEventListener("beforeunload", function () {
                if (window.hasRoles)
                    return;
                ils.trackMetric({ metricName: "CDPClickCount", count: cdpClicks });
                ils.trackMetric({ metricName: "FilterUsageCount", count: filterUses });
                ils.trackMetric({ metricName: "FilterUndoCount", count: showcaseListings.filterUndos });
                ils.trackMetric({ metricName: "AttributeClickCount", count: attributeClicks });
                //ga("send", "event", "CDPClicks", "alternate", cdpClicks);
                //ga("send", "event", "AttributeClicks", "alternate", attributeClicks);
                //ga("send", "event", "FilterUses", "alternate", filterUses);
                //ga("send", "event", "FilterUndos", "alternate", filterUndos);
                if (priceUsed) {
                    ils.trackSearchFilterUsedEvent({ filterName: "price" });
                    //ga("send", "event", "PriceUsed", "alternate", 1);
                }
                if (bedUsed) {
                    ils.trackSearchFilterUsedEvent({ filterName: "bedroom" });
                    //ga("send", "event", "BedUsed", "alternate", 1);
                }
                if (bathUsed) {
                    ils.trackSearchFilterUsedEvent({ filterName: "bathroom" });
                    //ga("send", "event", "BathUsed", "alternate", 1);
                }
                if (travelTimeUsed) {
                    ils.trackSearchFilterUsedEvent({ filterName: "traveltime" });
                    //ga("send", "event", "TravelTimeUsed", "alternate", 1);
                }
            });
            document.querySelectorAll("#filter-categories li").forEach((elem) => {
                elem.addEventListener("click", (ev) => {
                    const currentTarget = ev.target;
                    if (currentTarget.classList.contains("active")) {
                        return;
                    }
                    attributeClicks++;
                });
            });
            //$("#filter-categories li").on('click', function () {
            //	if ($(this).hasClass("active"))
            //		return;
            //	attributeClicks++;
            //});
            document.querySelectorAll(".filters-panel select").forEach((elem, key, parent) => {
                elem.addEventListener("change", (ev) => {
                    const currentEl = ev.target;
                    if (currentEl.value === "") {
                        showcaseListings.filterUndos++;
                    }
                    else {
                        filterUses++;
                    }
                });
            });
            //$(".filters-panel select").on("change", function () {
            //	if ($(this).val() === "")
            //		filterUndos++;
            //	else
            //		filterUses++;
            //});
            document.querySelectorAll(".filters-panel .checkboxes input").forEach((elem) => {
                elem.addEventListener("click", (evt) => {
                    const currentTarget = evt.target;
                    if (currentTarget.checked) {
                        filterUses++;
                    }
                    else {
                        showcaseListings.filterUndos++;
                    }
                });
            });
            //$(".filters-panel .checkboxes input").on('click', function () {
            //	if ($(this).is(":checked"))
            //		filterUses++;
            //	else
            //		filterUndos++;
            //});
            document.querySelectorAll(".filter-reset").forEach((elem) => {
                elem.addEventListener('click', () => {
                    showcaseListings.filterUndos++;
                });
            });
            document.getElementById("uxFilterAddress").addEventListener("change", () => {
                travelTimeUsed = true;
            });
            // This is how scrolling lazy loads new showcase items into the view
            const listingsObserver = new IntersectionObserver(async (entries) => {
                for (const entry of entries) {
                    if (entry.isIntersecting) {
                        globalThis.currentFilter = GetFilterJSONString();
                        await ShowNextPage();
                    }
                }
            }, {
                rootMargin: "100px 0px 100px 0px",
                threshold: 0.00
            });
            const listingObserverTarget = document.querySelector(".prefiltered-content-below");
            listingsObserver.observe(listingObserverTarget);
        });
        /**
         * This will run a final fetch of the communities to ensure that the view is fully loaded with all the
         * communities that are available. This is necessary because the initial load only loads a subset of the entire
         * data set of communities to enhance the initial load time of the page.
         * @returns {Promise<void>}
         */
        async function finalizeInitialLoad() {
            isInitialLoad = true;
            await LoadNewSet();
            showcaseListings.viewModel.ReadyToLoadData(true);
        }
        function HookupCommunityEventHandlers() {
            document.querySelectorAll(".community").forEach((elem) => {
                elem.addEventListener("click", (evt) => {
                    let element = evt.target;
                    if (!element.hasAttribute("href")) {
                        element = element.closest("[href]");
                    }
                    if (element.dataset.hasAb) {
                        ils.trackABView({
                            communityId: parseInt(element.dataset.id),
                            communityName: element.dataset.title,
                            testName: `${abMainImageName}Click`,
                            test_context: (abShowAlternate ? "alternate" : "main")
                        });
                        //ga("send", "event", abMainImageName, (abShowAlternate ? "alternate" : "main"), element.dataset.id);
                    }
                    ils.trackCommunityClickedEvent({
                        communityId: parseInt(element.dataset.id),
                        communityName: element.dataset.title,
                        communityUrl: element.dataset.url,
                        isFeaturedIcon: !element.dataset.featuredIcon
                            ? false
                            : element.dataset.featuredIcon.toLowerCase() === "true"
                    });
                    cdpClicks++;
                });
            });
        }
        function ThingsToDoOnResize() {
            LoadTabs();
            SetTitlePosition();
            SetResultsToFixed();
        }
        function LoadTabs() {
            if (breakpoint() !== "mobile" || isTablet())
                return;
            $(".showcase-tabs a").off('click.showcaseTabs').on('click.showcaseTabs', async function (e) {
                if ($(this).hasClass("filter-reset") || $(this).hasClass("copy-filter-link-mobile"))
                    return;
                e.preventDefault();
                const href = $(this).attr("href") || "";
                $(".mobile-tab.active").removeClass("active");
                $(href).addClass("active");
                if (href.indexOf("#filter-panel") >= 0) {
                    $(".tab-results,.tab-map").removeClass("hidden");
                    $(".tab-filter,.tab-list").addClass("hidden");
                    showcaseListings.viewModel.ShowMobileFilters(true);
                    showcaseListings.viewModel.MobileFilterPendingRefresh(true);
                    $("html, body").stop(true).animate({
                        scrollTop: $(".showcase-title").offset().top + $(".showcase-title").outerHeight(true)
                    }, 200);
                    if (initialFilterDisplay) {
                        $("#filter-categories li").css("max-width", $("#filter-categories").width() / 3);
                        globalThis.SetupResponsiveCarousel($("#filter-categories"));
                        $("#filter-categories ul").css("left", 0);
                        $(".ui-slider").each(function () {
                            if ($(this).find(".ui-slider-handle").length === 2)
                                UnstackSliderLabels($(this).find(".ui-slider-handle:first"), $(this).slider("option", "values")[0], $(this).slider("option", "values")[1]);
                        });
                        if (!mapsAreInitialized && !loadingMaps) {
                            loadingMaps = true;
                            ils.loadMapScripts(async function () {
                                await LoadNewSet();
                                mapsAreInitialized = true;
                                loadingMaps = false;
                            });
                        }
                        initialFilterDisplay = false;
                    }
                    else {
                        if (!mapsAreInitialized && !loadingMaps) {
                            loadingMaps = true;
                            ils.loadMapScripts(async function () {
                                const callbackPromise = new Promise((resolve) => {
                                    setTimeout(async () => {
                                        mapsAreInitialized = true;
                                        loadingMaps = false;
                                        resolve();
                                    }, 10);
                                });
                                await callbackPromise;
                            });
                        }
                    }
                }
                else if (href.indexOf("#results") >= 0) {
                    showcaseListings.viewModel.ShowMobileFilters(false);
                    $(".tab-filter, .tab-map").removeClass("hidden");
                    $(".tab-results,.tab-list").addClass("hidden");
                    if (showcaseListings.viewModel.MobileFilterPendingRefresh()) {
                        showcaseListings.viewModel.MobileFilterPendingRefresh(false);
                        showcaseListings.viewModel.ShowKnockoutView(true);
                        await LoadNewSet();
                    }
                    onListTabClick();
                }
                else {
                    $(".tab-map, .tab-results").addClass("hidden");
                    $(".tab-list, .tab-filter").removeClass("hidden");
                    showcaseListings.viewModel.ShowMobileFilters(false);
                }
                if (href.indexOf("#map") >= 0) {
                    if (!mapsAreInitialized) {
                        isInitialLoad = true;
                        ils.loadMapScripts(async function () {
                            await mapClickHandler(true);
                        });
                    }
                    else if (showcaseListings.viewModel.MobileFilterPendingRefresh()) {
                        showcaseListings.viewModel.MobileFilterPendingRefresh(false);
                        await mapClickHandler(true);
                    }
                    else {
                        await mapClickHandler(false);
                    }
                }
            });
        }
        async function mapClickHandler(shouldLoadNewSet) {
            const contentDisplay = document.getElementById("content-display");
            contentDisplay.classList.toggle("not-in-mobile", false);
            contentDisplay.classList.toggle("mobile-map", true);
            document.querySelector("footer").classList.toggle("hide", true);
            if (shouldLoadNewSet) {
                showcaseListings.viewModel.MobileFilterPendingRefresh(false);
                const currentMaxPageSize = showcaseListings.viewModel.PageSize();
                showcaseListings.viewModel.PageSize(showcaseListings.viewModel.TotalRowCount());
                await LoadNewSet();
                showcaseListings.MapResized();
                showcaseListings.fitBoundsToPins();
                await setMapZoom(currentMaxPageSize);
            }
            else {
                showcaseListings.MapResized();
                showcaseListings.fitBoundsToPins();
                await setMapZoom(showcaseListings.viewModel.PageSize());
            }
            async function setMapZoom(maxPageSize) {
                let smzTimeoutPromise = new Promise((resolve) => {
                    setTimeout(() => {
                        setMapZoom(17);
                        showcaseListings.viewModel.PageSize(maxPageSize);
                        resolve();
                    }, 20);
                });
                await smzTimeoutPromise;
            }
        }
        function onListTabClick() {
            const contentDisplay = document.getElementById("content-display");
            contentDisplay.classList.toggle("not-in-mobile", true);
            contentDisplay.classList.toggle("mobile-map", false);
            document.querySelector("footer").classList.toggle("hide", false);
            document.getElementById("content-display").removeAttribute("style");
            document.querySelector(".prefiltered-content-below").classList.toggle("active", true);
        }
        function SetTitlePosition() {
            if ($(".showcase-title").hasClass("minimized") || (breakpoint() === "mobile" && !isTablet()))
                return;
            $(".showcase-title").outerWidth($(window).width() - $(".filters-results").width() - 25 - 2 * parseInt($(".showcase-title").css("padding-right")));
        }
        function footerIsInViewPort() {
            const viewportWidth = globalThis.innerWidth || document.documentElement.clientWidth;
            const viewportHeight = globalThis.innerHeight || document.documentElement.clientHeight;
            const footerContainer = document.querySelector("footer");
            const rect = footerContainer.getBoundingClientRect();
            return rect.top >= 0 &&
                rect.left >= 0 &&
                rect.top < ((viewportHeight - 1)) &&
                rect.right < (viewportWidth);
        }
        function getMenuRectangle() {
            var menuRect = document.querySelector(".container-fluid,.navigation").getBoundingClientRect();
            return menuRect;
        }
        function SetResultsToFixed() {
            if (breakpoint() === "mobile" && !isTablet())
                return;
            $(".filters-results").on("scroll", function () {
                setDesktopFiltersBar();
            });
            globalThis.addEventListener("scroll", function () {
                setDesktopFiltersBar();
            });
            $(".show-footer").css("margin-left", $(".filters-results").width() + 75);
        }
        function setDesktopFiltersBar() {
            const footerIsVisible = footerIsInViewPort();
            const menuRect = getMenuRectangle();
            const filtersPanelRect = document.querySelector(".filters").getBoundingClientRect();
            const bottomAreaRect = document.querySelector(".bottom-area").getBoundingClientRect();
            if (!footerIsVisible && filtersPanelRect.bottom - bottomAreaRect.height < menuRect.bottom) {
                $(".filters").addClass("fix-top").css("margin-bottom", $(".bottom-area").outerHeight(true));
                $(".bottom-area").addClass("fix-top").css({ "max-width": $(".filters").width() });
                if (menuRect.bottom <= 0) {
                    $(".bottom-area").css("top", 0);
                }
                else {
                    $(".bottom-area").css("top", menuRect.bottom);
                }
            }
            else {
                $(".filters").css("margin-bottom", 0);
                if (filtersPanelRect.bottom - bottomAreaRect.height <= 0) {
                    if (menuRect.bottom <= 34) {
                        $(".bottom-area").addClass("fix-top").css({ "max-width": $(".filters").width() });
                        if (menuRect.bottom < 0) {
                            $(".bottom-area").css("top", 0);
                        }
                        else {
                            $(".bottom-area").css("top", menuRect.bottom + 1);
                        }
                    }
                }
                else {
                    $(".bottom-area").removeClass("fix-top").css("max-width", "none");
                }
            }
            CheckIfABImageInView();
        }
        function ClearRangeSlider(sliderElement) {
            if (sliderElement.length > 0) {
                sliderElement.slider("values", [sliderElement.slider("option", "min"), sliderElement.slider("option", "max")]);
                sliderElement.find(".ui-slider-handle").removeClass("on-top");
                sliderElement.find(".handle-text:first").html(sliderElement.slider("option", "min"));
                sliderElement.find(".handle-text:last").html(sliderElement.slider("option", "max"));
            }
        }
        function ClearSlider(sliderElement) {
            sliderElement.slider("values", [sliderElement.slider("option", "max")]);
            sliderElement.find(".handle-text:last").html(sliderElement.slider("option", "max"));
        }
        function ClearListBoxOrDropdown(theElement) {
            if (theElement.val() !== "")
                theElement.val("");
        }
        function ClearRadioButtonList(theElement) {
            if (theElement.val() === "all")
                theElement.prop("checked", true);
            else
                theElement.prop("checked", false);
        }
        function ClearRadioButton(theElement) {
            if (theElement.parent().is(":last-child"))
                theElement.prop("checked", true);
            else
                theElement.prop("checked", false);
        }
        function ClearCheckBox(theElement) {
            theElement.siblings().removeClass("focused");
            if (theElement.siblings().text() === "All") {
                theElement.prop("checked", true);
                theElement.prop("disabled", true);
            }
            else
                theElement.prop("checked", false);
        }
        function ClearMobileDropdownFilter(dropdownContainer) {
            const minValue = dropdownContainer.find("select:first option:first").val();
            const maxValue = dropdownContainer.find("select:first option:last").val();
            dropdownContainer.find("select:first").val(minValue);
            dropdownContainer.find("select:last").val(maxValue);
        }
        function ClearRegionFilter() {
            $("input[id*=uxRegionCheckBoxList]").each(function () {
                ClearCheckBox($(this));
            });
            showcaseListings.viewModel.Neighborhoods("");
        }
        function sliderUpdateFilter(sliderElement) {
            const sliderValue = sliderElement.slider("value");
            const attributeID = GetAttributeID(sliderElement.parent());
            const currentFilterItem = GetFilterByID(attributeID.val());
            if (sliderValue === "0")
                currentFilterItem.Value("");
            else
                currentFilterItem.Value(sliderValue);
        }
        function rangeSliderUpdateFilter(sliderElement) {
            const sliderValue1 = sliderElement.slider("values", 0);
            const sliderValue2 = sliderElement.slider("values", 1);
            const attributeID = GetAttributeID(sliderElement.parent());
            const currentFilter = GetFilterByID(attributeID.val());
            if (sliderValue1 === sliderElement.slider("option", "min") && sliderValue2 === sliderElement.slider("option", "max")) {
                currentFilter.Value("");
                if (globalThis.loaded)
                    showcaseListings.filterUndos++;
            }
            else {
                currentFilter.Value(`>${sliderValue1}<${sliderValue2}`);
                if (globalThis.loaded)
                    filterUses++;
            }
        }
        function BindPriceSlider() {
            if (breakpoint() === "mobile" && !isTablet()) {
                const values = showcaseListings.viewModel.ByUnit() ? unitPrices : roomPrices;
                $("#uxPriceMin option,#uxPriceMax option").remove();
                for (let i = values[0]; i <= values[values.length - 1]; i = i + 50) {
                    $("#uxPriceMin,#uxPriceMax").append(`<option value="${i}">$${i}</option>`);
                }
                $("#uxPriceMax").val(values[values.length - 1]);
                return;
            }
            // else
            var sliderElement = $("#uxPriceRangeSlider");
            const values = showcaseListings.viewModel.ByUnit() ? unitPrices : roomPrices;
            var value1 = sliderElement.data("value1") ? sliderElement.data("value1") : values[0];
            var value2 = sliderElement.data("value2") ? sliderElement.data("value2") : values[values.length - 1];
            sliderElement.removeAttr("data-value1").removeAttr("data-value2");
            sliderElement.data({ value1: null, value2: null });
            sliderElement.slider({
                range: true,
                step: 25,
                min: values[0],
                max: values[values.length - 1],
                values: [value1, value2],
                create: function (event, ui) {
                    if (sliderElement.find(".handle-text").length == 0)
                        sliderElement.find(".ui-slider-handle").append('<span class="handle-text"></span>');
                    sliderElement.find(".ui-slider-handle:last").addClass("reverse");
                    UnstackSliderLabels(sliderElement.find(`.ui-slider-handle:${(value2 == values[0] ? "last" : "first")}`), value1, value2);
                    priceSliderUpdateFilter(sliderElement);
                },
                slide: function (event, ui) {
                    const handle = $(ui.handle);
                    const handleText = handle.find(".handle-text");
                    handleText.html(`$${ui.value}`);
                    UnstackSliderLabels(handle, ui.values[0], ui.values[1]);
                },
                stop: function (event, ui) {
                    priceSliderUpdateFilter(sliderElement);
                    priceUsed = true;
                }
            });
            sliderElement.find(".handle-text:first").html(`$${value1}`);
            sliderElement.find(".handle-text:last").html(`$${value2}`);
        }
        function BindBedroomSlider() {
            var sliderElement = $("#uxBedroomRangeSlider");
            var values = bedrooms;
            var value1 = sliderElement.data("value1") != null ? sliderElement.data("value1") : values[0];
            var value2 = sliderElement.data("value2") != null ? sliderElement.data("value2") : values[values.length - 1];
            sliderElement.removeAttr("data-value1").removeAttr("data-value2");
            sliderElement.slider({
                range: true,
                min: parseInt(values[0]),
                max: parseInt(values[values.length - 1]),
                values: [value1, value2],
                create: function (event, ui) {
                    if (sliderElement.find(".handle-text").length === 0)
                        sliderElement.find(".ui-slider-handle").append('<span class="handle-text"></span>');
                    sliderElement.find(".handle-text:first").html(FormatBedroomText(value1));
                    sliderElement.find(".handle-text:last").html(FormatBedroomText(value2));
                    sliderElement.find(".ui-slider-handle:last").addClass("reverse");
                    UnstackSliderLabels(sliderElement.find(`.ui-slider-handle:${value2 === values[0] ? "last" : "first"}`), value1, value2);
                    bedroomSliderUpdateFilter(sliderElement);
                },
                slide: function (event, ui) {
                    const handle = $(ui.handle);
                    handle.find(".handle-text").html(FormatBedroomText(ui.value));
                    UnstackSliderLabels(handle, ui.values[0], ui.values[1]);
                },
                stop: function (event, ui) {
                    bedroomSliderUpdateFilter(sliderElement);
                    bedUsed = true;
                }
            });
        }
        function BindBathroomSlider() {
            var sliderElement = $("#uxBathroomRangeSlider");
            var values = bathrooms;
            var value1 = sliderElement.data("value1") ? sliderElement.data("value1") : values[0];
            var value2 = sliderElement.data("value2") ? sliderElement.data("value2") : values[values.length - 1];
            sliderElement.removeAttr("data-value1").removeAttr("data-value2");
            sliderElement.slider({
                range: true,
                min: parseInt(values[0]),
                max: parseInt(values[values.length - 1]),
                values: [value1, value2],
                create: function (event, ui) {
                    if (sliderElement.find(".handle-text").length === 0)
                        sliderElement.find(".ui-slider-handle").append('<span class="handle-text"></span>');
                    sliderElement.find(".handle-text:first").html(value1);
                    sliderElement.find(".handle-text:last").html(value2);
                    sliderElement.find(".ui-slider-handle:last").addClass("reverse");
                    UnstackSliderLabels(sliderElement.find(`.ui-slider-handle:${value2 === values[0] ? "last" : "first"}`), value1, value2);
                    bathroomSliderUpdateFilter(sliderElement);
                },
                slide: function (event, ui) {
                    const handle = $(ui.handle);
                    handle.find(".handle-text").html(ui.value.toString());
                    UnstackSliderLabels(handle, ui.values[0], ui.values[1]);
                },
                stop: function (event, ui) {
                    bathroomSliderUpdateFilter(sliderElement);
                    bathUsed = true;
                }
            });
        }
        function FormatBedroomText(numBeds) {
            return numBeds === 0 ? "Studio" : numBeds + "BR";
        }
        function priceSliderUpdateFilter(sliderElement) {
            let minValue, maxValue;
            try {
                // Attempt to fetch slider values - desktop
                minValue = sliderElement.slider("values", 0);
                maxValue = sliderElement.slider("values", 1);
            }
            catch (error) {
                // If an error occurs, fall back to fetching data attributes - mobile
                minValue = sliderElement.data('value1');
                maxValue = sliderElement.data('value2');
            }
            var minSliderValue, maxSliderValue;
            try {
                minSliderValue = sliderElement.slider("option", "min");
                maxSliderValue = sliderElement.slider("option", "max");
            }
            catch (error) {
                minSliderValue = $('#uxPriceMin option:first').val();
                maxSliderValue = $('#uxPriceMax option:last').val();
                selectOptionByValue('uxPriceMin', minValue);
                selectOptionByValue('uxPriceMax', maxValue);
            }
            showcaseListings.viewModel.PriceRange((minValue === minSliderValue && maxValue === maxSliderValue) ? "" : minValue + "-" + maxValue);
        }
        function selectOptionByValue(selectId, value) {
            value = String(value);
            var selectElement = $('#' + selectId);
            if (selectId == 'uxPriceMin') {
                showcaseListings.viewModel.PriceMin(value);
            }
            else if (selectId == 'uxPriceMax') {
                showcaseListings.viewModel.PriceMax(value);
            }
            else {
                console.error('Wrong selectId');
            }
            selectElement.trigger('change');
        }
        function bedroomSliderUpdateFilter(sliderElement) {
            var minValue = sliderElement.slider("values", 0);
            var maxValue = sliderElement.slider("values", 1);
            if (minValue === "Studio")
                minValue = 0;
            if (maxValue === "Studio")
                maxValue = 0;
            if (minValue === sliderElement.slider("option", "min") && maxValue === sliderElement.slider("option", "max"))
                showcaseListings.viewModel.BedroomRange("");
            else
                showcaseListings.viewModel.BedroomRange(minValue + "-" + maxValue);
        }
        function bathroomSliderUpdateFilter(sliderElement) {
            const minValue = sliderElement.slider("values", 0);
            const maxValue = sliderElement.slider("values", 1);
            if (minValue === sliderElement.slider("option", "min") && maxValue === sliderElement.slider("option", "max"))
                showcaseListings.viewModel.BathroomRange("");
            else
                showcaseListings.viewModel.BathroomRange(minValue + "-" + maxValue);
        }
        function travelTimeSliderUpdateFilter(sliderElement) {
            const value = sliderElement.slider("value");
            showcaseListings.viewModel.TravelTime(value);
        }
        function UnstackSliderLabels(handle, value1, value2) {
            setTimeout(function () {
                const handleText = handle.find(".handle-text");
                const rightHandleLabel = handle.parent().find(".ui-slider-handle:last .handle-text");
                if (value1 === value2) {
                    handle.addClass("on-top");
                    handleText.html("Only");
                }
                else {
                    handle.removeClass("on-top");
                }
                const leftHandleLabel = handle.parent().find(".ui-slider-handle:first .handle-text");
                leftHandleLabel.css("margin-left", "0");
                rightHandleLabel.css("margin-left", "0");
                const leftHandleEnd = leftHandleLabel.offset().left + leftHandleLabel.outerWidth(true);
                const rightHandleStart = rightHandleLabel.offset().left;
                const offset = rightHandleStart - leftHandleEnd;
                if (offset < 0) {
                    if (handle.hasClass("reverse"))
                        rightHandleLabel.css("margin-left", offset + "px");
                    else
                        leftHandleLabel.css("margin-left", offset + "px");
                }
            }, 5);
        }
        window.addEventListener("popstate", function (e) {
            if (!isInitialLoad) {
                location.reload();
            }
        });
    })(showcaseListings = ils.showcaseListings || (ils.showcaseListings = {}));
})(ils || (ils = {}));
